export default __webpack_public_path__ + "static/media/ic-clock.3d2dfbf1.svg";